import { SingleSelectGroup } from '@xo-union/tk-component-switches';
import React, { useState } from 'react';

import { Checkable, CustomCheckbox } from '../CustomCheckbox';
import styles from './index.scss';

interface CropRatioProps extends Checkable {
  type: string;
}

const CropRatio: React.FC<CropRatioProps> = ({ checked, type }) => {
  const classes = [styles.ratio];
  const typeClass = `shape${type.replace(':', '-')}`;

  if (checked) {
    classes.push(styles.selected);
  }

  return (
    <div className={classes.join(' ')}>
      <div className={`${styles.inner} ${styles[typeClass]}`} />
    </div>
  );
};

interface Props {
  ratios: string[];
  defaultRatio: string;
  onChange: (arg0: string) => void;
}

export const CropRatios: React.FC<Props> = props => {
  const { ratios, defaultRatio, onChange } = props;
  const [selected, setSelected] = useState(defaultRatio);

  const handleChange = (value: any) => {
    onChange(value);
    setSelected(value);
  };

  return (
    <div className={styles.ratios}>
      <span className={styles.text}>Crop:</span>
      <SingleSelectGroup value={selected} onValueChange={handleChange}>
        {ratios.map(ratio => (
          <CustomCheckbox dataTestId={`shape${ratio.replace(':', '-')}`} key={ratio} value={ratio}>
            {({ checked }): React.ReactElement => <CropRatio checked={checked} type={ratio} />}
          </CustomCheckbox>
        ))}
      </SingleSelectGroup>
    </div>
  );
};
